<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('tips_search') || '外借单号/外借销售搜索......'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_borrowNo') || '外借单号'">
              <el-input
                v-model.trim="form.stockBorrowNo"
                :placeholder="$l('tips_input_borrow_no') || '请输入外借单号'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.billStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.bill_status_new') || '新增'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.bill_status_reviewed') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.bill_status_deleted') || '作废'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_sales') || '外借销售'">
              <dict-select
                clearable
                v-model="form.useSalesCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('tips_select_sales') || '请选择业务人员'"
                :selectedLabel.sync="form.useSalesName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_use_place') || '使用地点'">
              <dict-select
                :placeholder="$l('tips_select_use_place') || '请输入使用地点'"
                size="small"
                clearable
                filterable
                v-model="form.usePlace"
                :body="usePlaceParams"
                url="/master/common/dict/biz"
                :selectedLabel.sync="form.usePlaceName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_customer') || '收货客户'">
              <dict-select
                clearable
                v-model="form.useCustCode"
                filterable
                url="/master/common/dict/customerSelect"
                :placeholder="$l('tips_select_customer') || '请选择客户'"
                style="width:100%"
                :selectedLabel.sync="form.useCustName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_factory') || '收货工厂'">
              <dict-select
                clearable
                size="small"
                filterable
                v-model="form.useFactoryCode"
                :placeholder="$l('tips_select_factory') || '请输入收货工厂'"
                url="/master/common/dict/scmSelect"
                :selectedLabel.sync="form.useFactoryName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  billStatusList: ['Y', 'N'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      usePlaceParams: { dictType: 'usePlace' },
    }
  },
  created() {
    this.query()
    this.$eventBus.$on('sampleStockBorrow', () => {
      this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    getForm() {
      return this.form
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'samplemanage-sampleStockBorrow-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
